import axios from '../../../../shared/axios/axios';
import newAxios from '../../../../shared/axios/new-api-axios';

import * as actionTypes from '../constants/actionTypes';

export const getOpportunities = (pageRequest) => {
  const url = `/opportunities-pipelines/get-opportunities`;

  return axios
    .post(url, pageRequest)
    .then((response) => (response ? response.data : null))
    .catch((err) => console.log(err));
};

const getOpportunityStagesStart = () => {
  return {
    type: actionTypes.GET_OPPORTUNITIES_STAGES_START,
  };
};

const getOpportunityStagesSuccess = (data) => {
  return {
    type: actionTypes.GET_OPPORTUNITIES_STAGES_SUCCESS,
    opportunityStages: data,
  };
};

const getOpportunityStagesFail = (error) => {
  return {
    type: actionTypes.GET_OPPORTUNITIES_STAGES_FAIL,
    error: error,
  };
};

export const getOpportunityStages = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getOpportunityStagesStart());
      const url = `/shared/get-opportunity-stages`;

      newAxios
        .get(url)
        .then((response) => {
          dispatch(getOpportunityStagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getOpportunityStagesFail(err));
          reject(err);
        });
    });
  };
};

const changeOpportunityStageStart = () => {
  return {
    type: actionTypes.CHANGE_OPPORTUNITY_STAGE_START,
  };
};

const changeOpportunityStageSuccess = (data) => {
  return {
    type: actionTypes.CHANGE_OPPORTUNITY_STAGE_SUCCESS,
  };
};

const changeOpportunityStageFail = (error) => {
  return {
    type: actionTypes.CHANGE_OPPORTUNITY_STAGE_FAIL,
    error: error,
  };
};

export const changeOpportunityStage = (id, stageId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(changeOpportunityStageStart());
      const url = `/opportunities-pipelines/change-status?id=${id}&stageId=${stageId}`;

      axios
        .post(url)
        .then((response) => {
          dispatch(changeOpportunityStageSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeOpportunityStageFail(err));
          reject(err);
        });
    });
  };
};

const deleteOpportunityStart = () => {
  return {
    type: actionTypes.DELETE_OPPORTUNITY_START,
  };
};

const deleteOpportunitySuccess = () => {
  return {
    type: actionTypes.DELETE_OPPORTUNITY_SUCCESS,
  };
};

const deleteOpportunityFail = (error) => {
  return {
    type: actionTypes.DELETE_OPPORTUNITY_FAIL,
    error: error,
  };
};

export const deleteOpportunity = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteOpportunityStart());
      const url = `/opportunities-pipelines/delete-opportunity?id=${id}`;

      axios
        .post(url)
        .then((response) => {
          dispatch(deleteOpportunitySuccess());
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteOpportunityFail(err));
          reject(err);
        });
    });
  };
};

const getOpportunityPipelinesControlConfigStart = () => {
  return {
    type: actionTypes.GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_START,
  };
};

const getOpportunityPipelinesControlConfigSuccess = (data) => {
  return {
    type: actionTypes.GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_SUCCESS,
    opportunityPipelinesControlConfig: data,
  };
};

const getOpportunityPipelinesControlConfigFail = (error) => {
  return {
    type: actionTypes.GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const getOpportunityPipelinesControlConfig = (createdFromRenewal) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getOpportunityPipelinesControlConfigStart());
      const url = `/opportunities-pipelines/get-opportunity-control-configuration?createdFromRenewal=${createdFromRenewal ? 'true' : 'false'}`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getOpportunityPipelinesControlConfigSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getOpportunityPipelinesControlConfigFail(err));
          reject(err);
        });
    });
  };
};

const saveOpportunityPipelinesControlConfigStart = () => {
  return {
    type: actionTypes.SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_START,
  };
};

const saveOpportunityPipelinesControlConfigSuccess = (data) => {
  return {
    type: actionTypes.SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_SUCCESS,
    saveControlConfigResult: data,
  };
};

const saveOpportunityPipelinesControlConfigFail = (error) => {
  return {
    type: actionTypes.SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const saveOpportunityPipelinesControlConfig = (createdFromRenewal, controlConfig) => {
  return (dispatch) => {
    dispatch(saveOpportunityPipelinesControlConfigStart());
    const url = `/opportunities-pipelines/save-opportunity-control-configuration`;

    axios
      .post(url, {
        createdFromRenewal: createdFromRenewal,
        config: { columns: controlConfig },
      })
      .then((response) => dispatch(saveOpportunityPipelinesControlConfigSuccess(response.data)))
      .catch((err) => dispatch(saveOpportunityPipelinesControlConfigFail(err)));
  };
};
